<template>
  <div>
    <el-button @click="test">{{menuName}}</el-button>
  </div>
</template>

<script>
export default {
  name: 'SmsSelectStudent',
  props: {
    gridData: {},
    menuName: ''
  },
  methods: {
    test () {
      let select = this.gridData.rowSelection
      this.$bus.$emit('smsSelectPhones', select)
    }
  }
}
</script>

<style lang="scss">

</style>
